import { RouteSheet } from '@/components/route-sheet';
import { useGetMatchedRoute } from '@/hooks/routing';
import { useI18n } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(tv)/tv/$id/(tv-profiles)/_sheet')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { id } = Route.useParams();
  const match = useGetMatchedRoute();
  let hasBack = false;
  let backAsRouterNavigateBack = false;
  let onBack: (() => void) | undefined;
  let title = '';
  const { t } = useI18n();
  switch (match.routeId) {
    case '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/(list)/':
      hasBack = false;
      backAsRouterNavigateBack = false;
      title = t('TvProfiles.LandingPage.Title');
      break;
    case '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/create/':
      hasBack = true;
      backAsRouterNavigateBack = false;
      title = t(
        match.search.kids ? 'TvProfiles.CreateProfile.KidsTitle' : 'TvProfiles.CreateProfile.Title',
      );
      break;
    case '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/':
      hasBack = true;
      backAsRouterNavigateBack = true;
      title = t(
        match.search.kids ? 'TvProfiles.UpdateProfile.KidsTitle' : 'TvProfiles.UpdateProfile.Title',
      );
      break;
    case '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/select-avatar/':
      hasBack = true;
      backAsRouterNavigateBack = true;
      title = t('TvProfiles.CreateProfile.Avatars.Title');
      break;
    case '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/contact-selection/':
      hasBack = true;
      backAsRouterNavigateBack = true;
      title = t('Common.ContactValidation.ContactSelection.SheetTitle');
      break;
    case '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/code-input/':
      hasBack = true;
      backAsRouterNavigateBack = true;
      title = t('Common.ContactValidation.CodeInput.SheetTitle');
      break;
    case '/(tv)/tv/$id/(tv-profiles)/_sheet/profiles/$profileId/update/pin-validation/':
      hasBack = true;
      onBack = () => void navigate({ to: '/tv/$id/profiles', params: { id } });
      title = t('TvProfiles.PinValidation.Title');
      break;
  }

  return (
    <RouteSheet
      onClose={() => navigate({ to: '/tv/$id', params: { id } })}
      options={{ hasBack, backAsRouterNavigateBack, onBack, title }}
    />
  );
}
